import * as React from 'react';
import { observer } from 'mobx-react';
import { IConfiguratorUIDto } from '@canvas-logic/clp-api-types';
import { IPrice } from '@canvas-logic/clp-domain';
import { Bootstrapper } from '@/ui-kit/domain/Bootstrapper';
import { RalPalette } from '@/UiBuilder/elements/RalAttributeCfgUIElement/RalPalette/RalPalette';

import { OptionsViewStateName } from '@/stores/OptionsConfiguratorUIStore';
import { CfgUIElementState } from '@/stores/CfgUIElementState';

import './cp.css';
import classNames from 'classnames';

interface IProps {
  bootstrapper: Bootstrapper;
  configuratorUI: IConfiguratorUIDto;
  configuration: {};
}

interface IState {
  prices: IPrice;
}

const Section = function ({ children }: { children: React.ReactNode }) {
  return (
    <div>
      <h2>Section</h2>
      {children}
    </div>
  );
};
export const UiBuilder: React.FC<IProps> = observer((props) => {
  const [prices, setPrices] = React.useState<IPrice>({});

  React.useEffect(() => {
    const brandColor = props.configuratorUI.brandColor || {
      r: 92,
      g: 110,
      b: 242,
    };
    if (brandColor) {
      const root: HTMLElement | null = document.querySelector(':root');
      if (root) {
        root.style.setProperty('--color-brand-rgb', `${brandColor.r},${brandColor.g},${brandColor.b}`);
        root.style.setProperty('--color-brand', `rgb(${brandColor.r},${brandColor.g},${brandColor.b})`);
      }
    }
  }, [props.configuratorUI.brandColor]);

  React.useEffect(() => {
    const configuratorUI = props.configuratorUI;

    if (configuratorUI?.theme?.overrideBasic && configuratorUI?.theme?.basic) {
      const style = document.createElement('style');
      style.setAttribute('id', 'overrideBasicTheme');
      style.innerHTML = configuratorUI?.theme?.basic;
      document.head.appendChild(style);
      return () => {
        document.head.removeChild(style);
      };
    }
  }, [props.configuratorUI.theme]);

  const { bootstrapper } = props;
  const { optionsViewStore } = bootstrapper;

  const mapper = React.useCallback((state: CfgUIElementState, key: string) => {
    return state.render(key);
  }, []);

  switch (optionsViewStore.view.name) {
    case OptionsViewStateName.INITIAL: {
      return <div className={classNames('cp-root')}>{bootstrapper.rootElement.render('root')}</div>;
    }
    case OptionsViewStateName.SELECT_CUSTOM_COLOR: {
      const viewState = optionsViewStore.view.state;
      const title = viewState.viewElement.uiControl.customColorOptions.title;

      return (
        <RalPalette
          title={title}
          onClickBack={optionsViewStore.setInitialView}
          colors={viewState.customColors}
          onSelectColor={viewState.setCustomColor}
          selectedColor={viewState.color?.value}
        />
      );
    }
    default:
      return null;
  }
});
